
const filters={
    timeToDate:function(timestamp){
        const date = new Date(timestamp*1000);
        return date.toLocaleString("zh-CN")
    },
    timeToDate2: function(timestamp) {
        const date = new Date(timestamp * 1000);
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
    
        return `${year}-${month}-${day}`;
    }


}
export default filters